import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('pengumuman/index', {params});
    },
    show(id) {
        return Service().get('pengumuman/show/'+id);
    },
    create(params) {
        return Service().post('pengumuman/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('pengumuman/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('pengumuman/delete/'+id);
    },
}
